import React from 'react'
import { useStaticQuery, graphql } from "gatsby"

export const usePageMetadata = () => {
    const { allPagesJson } = useStaticQuery(
        graphql`
        query PageMetaData {
            allPagesJson {
                edges {
                    node {
                        pages {
                            id
                            name
                            name_ja
                            pathname
                            is_home
                            link_type
                        }
                        socials {
                            id
                            name
                            title
                            url
                            icon_type
                        }
                    }
                }
            }
        }
      `
    )
    return allPagesJson.edges[0].node;
}